import AppContainerFromCreditControl from '../../../credit-control/src/components/AppContainer';
import { useUserProfile } from '../../../credit-control/src/hooks/useUserProfile';
import { WootricProvider } from '../../../credit-control/src/providers/WootricProvider';
import { useUserContext } from '../providers/UserContextProvider';

interface CreditControlWithUserContextProps {
  apiUrl: string;
  financialsApiUrl?: string;
  wootricToken?: string;
  feedbackAccountToken?: string;
  feedbackApiHost?: string;
  feedbackMfeVersion?: string;
  feedbackReDisplayAfterDays?: string;
}

/**
 * Wrapper component that bridges UserContextProvider with the credit-control AppContainer.
 * Passes the userContext companies to CompanyProvider via the settings prop.
 * Also integrates WootricProvider for NPS survey functionality.
 */
export function CreditControlWithUserContext({
  apiUrl,
  financialsApiUrl,
  wootricToken,
  feedbackAccountToken,
  feedbackApiHost,
  feedbackMfeVersion,
  feedbackReDisplayAfterDays,
}: CreditControlWithUserContextProps): React.ReactElement {
  const { companies, isLoading, userContext, refetch } = useUserContext();
  const { user: wootricUser } = useUserProfile({ userContext, isLoading });

  return (
    <WootricProvider user={wootricUser} wootricToken={wootricToken}>
      <AppContainerFromCreditControl
        settings={{
          apiUrl,
          financialsApiUrl,
          host: 'app-prod',
          externalCompanies: companies,
          externalCompaniesLoading: isLoading,
          onRefreshUserContext: refetch,
          feedbackAccountToken,
          feedbackApiHost,
          feedbackMfeVersion,
          feedbackReDisplayAfterDays,
        }}
      />
    </WootricProvider>
  );
}
